import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadLegalEntityFormListFailed,
  loadLegalEntityFormListSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadLegalEntityFormList(action) {
  try {
    const pool = {
      subject_type: 'application',
      subject_id: action.payload,
    };
    const url = `${BACKEND_URL}/proxy/backend/api/v1/registries/legal-entity-forms/all`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadLegalEntityFormListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadLegalEntityFormListFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadLegalEntityFormListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
